// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"b6b37840","140":"d9126c49","787":"6f38c2cd"}[chunkId] + ".chunk.js";
};